import React from "react";
import { en, es, ca, texts } from "../lib/constants";

export const Language = ({ userID, language, changeLanguage, isMobile }) => {
  const availableLanguages = [es];

  const handleLanguageChange = (event) => {
    const selectedLanguage = event.target.value;
    changeLanguage(userID, selectedLanguage);
  };

  if (availableLanguages.length <= 1) {
    return null;
  }

  return (
    <div
      style={{
        fontWeight: "bold",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "2px",
      }}
    >
      <select
        value={language}
        onChange={handleLanguageChange}
        className="language-select"
        style={{ fontSize: isMobile ? "14px" : "18px", cursor: "pointer" }}
      >
        {availableLanguages.map((lang) => (
          <option key={lang} value={lang} title={texts[lang]?.navbarLanguageTitle}>
            {lang.toUpperCase()}
          </option>
        ))}
      </select>
    </div>
  );
};
